import { render, staticRenderFns } from "./b12.vue?vue&type=template&id=2236f5f1&scoped=true"
import script from "./b12.vue?vue&type=script&lang=js"
export * from "./b12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2236f5f1",
  null
  
)

export default component.exports